/* eslint-disable functional/no-conditional-statement */
import { isUserLoggedIn } from "../../payment/miscellaneous/parseCookie";
import { dispatchSignInInfoEvent } from "./dispatchSignInInfoEvent";
import { getSignInInfo } from "./getSignInInfo";
import { getSignInResponse } from "./getSignInResponse";

export async function setToken(
  tag: "on-load" | "on-fetch" | "login-requested"
): Promise<unknown> {
  const logInUser =
    tag === "login-requested" || isUserLoggedIn(document.cookie); // Set by partner side using SDK

  if (logInUser === false) {
    return;
  } else {
    const signInInfo = getSignInInfo();

    if (
      signInInfo === "initial" ||
      signInInfo.expiresAt.getTime() < new Date().getTime()
    ) {
      await getSignInResponse(tag);
    } else if (tag === "on-load") {
      // requires intial event to trigger loop
      return dispatchSignInInfoEvent({ tag: "normalized", info: signInInfo });
    } else {
      return;
    }
  }
}
